import {
  createContext,
  type FC,
  type PropsWithChildren,
  useMemo,
  useState,
} from "react";

export interface UserInfo {
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  isFirstSession?: boolean;
  hopperUserId?: string;
}

export interface AuthState {
  userInfo?: UserInfo;
  isLoggedIn: boolean;

  login: () => void;
  logout: () => void;
  setUserInfo: (v: UserInfo) => void;
  needOnboarding: () => boolean;
  //TODO: can move rewards info, e.g. balance info here
}

const noop = () => {
  console.log("empty function");
};

const defaultInitState: AuthState = {
  isLoggedIn: false,

  login: noop,
  logout: noop,
  setUserInfo: noop,
  needOnboarding: () => false,
};

export const AuthContext = createContext<AuthState>(defaultInitState);

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(defaultInitState.isLoggedIn);
  const [userInfo, setUserInfo] = useState(defaultInitState.userInfo);

  const stateValue: AuthState = useMemo(
    () => ({
      userInfo: userInfo,
      isLoggedIn: isLoggedIn,
      login: () => setIsLoggedIn(true),
      logout: () => setIsLoggedIn(false),
      setUserInfo: (v: UserInfo) => setUserInfo(v),
      needOnboarding: () =>
        !userInfo?.firstName ||
        // Biforst stores hardcoded "N/A" as givenName in DB when missing.
        userInfo?.firstName?.trim().toUpperCase() === "N/A" ||
        !userInfo?.email ||
        !userInfo?.lastName ||
        // Biforst stores hardcoded "N/A" as surName in DB when missing.
        userInfo?.lastName?.trim().toUpperCase() === "N/A" ||
        !userInfo?.phoneNumber,
    }),
    [isLoggedIn, userInfo]
  );

  return <AuthContext.Provider value={stateValue} children={children} />;
};
